import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import EditorPicks from './components/EditorPicks';
import WeeklyHot from './components/WeeklyHot';
import { siteConfig } from '@/mocks/site';

export default function Home() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
    email: siteConfig.email,
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressCountry: 'CN',
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteConfig.url}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${siteConfig.name} - 首页`,
    description: siteConfig.description,
    url: siteConfig.url,
    isPartOf: {
      '@type': 'WebSite',
      name: siteConfig.name,
      url: siteConfig.url,
    },
  };

  return (
    <>
      <SEOHead
        title={`${siteConfig.name} - ${siteConfig.tagline} | 最新影视资讯、深度影评、热门剧集推荐`}
        description={siteConfig.description}
        keywords="电影资讯,剧集推荐,影评,动漫,综艺,影视资讯,观影指南,91看片网"
        canonicalUrl={siteConfig.url}
        ogImage="https://readdy.ai/api/search-image?query=modern%20cinema%20website%20homepage%20design%20with%20warm%20lighting%2C%20movie%20posters%20display%2C%20clean%20minimal%20layout%2C%20cinematic%20atmosphere%2C%20red%20and%20gold%20accents%2C%20professional%20web%20design&width=1200&height=630&seq=og-homepage&orientation=landscape"
        ogImageWidth={1200}
        ogImageHeight={630}
        structuredData={[organizationSchema, websiteSchema, webPageSchema]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <FeaturedArticles />
          <EditorPicks />
          <WeeklyHot />

          <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
            <div className="bg-accent-50 border border-accent-100 rounded-lg p-8 md:p-10 text-center">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                热爱光影，从这里开始
              </h2>
              <p className="text-foreground-600 max-w-xl mx-auto text-sm leading-relaxed">
                每天为你精选最新最热的影视内容。无论你是电影发烧友还是追剧达人，
                在91看片网都能找到属于你的那份光影感动。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-6">
                <a href="#top" className="px-6 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                  开始探索
                </a>
              </div>
            </div>
          </section>
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}